import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><img parentName="p" {...{
        "src": "http://www.reeves.nl/upload/guinea-1.gif",
        "alt": "Gulf of Guinea, Borborema and African Rifts - the animation may take a few second to load"
      }}></img></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
    </ul>
    <p>{`The animation demonstrates the 'escape' of South America from the western margin of Africa in the region of the Gulf of Guinea.  The tight fit of South America to
Africa can only be achieved by relative movement of Northwest Africa with respect to the rest of Africa (Africa - Congo). The model has both Northwest Africa and
Northeast Africa rotating clockwise about poles in central Africa in the interval 142.3 to 113.2 Ma.  This coincides with a period of activity off the eastern
margin of Africa, the movements of east and west Africa coming together with those of India in the proto-Owen Fracture Zone off Somalia. `}</p>
    <p>{`The rotation involves relative movements between Northwest Africa, Northeast Africa and Africa Congo manifested in the extensive rift systems crossing Africa
from Nigeria to Kenya.  The situation is complicated by movements of smaller fragment in the region of Nigeria.  The fragment Cameroon North initially follows
South America westwards with sinistral movement on one of the major faults mapped in Cameroon.  Nigeria's Hawal Massif also moves with rfespect to Cameroon
North.  A small movment between the Niger block and the rest of N orthwest Africa opens the rift in Nigeria that follows the Niger River.`}</p>
    <p>{`South America rotates initially about a point near the coastline of Nigeria but undergoes a significant change in travel direction at about 113.2 Ma when the
movement direction of the next 30 Myr is established and Northwest Africa is fixed in approximately its present position with respect to the rest of Africa.`}</p>
    <p>{`The geological map information in the animation relates to a single `}<em parentName="p">{`rigid`}</em>{` Africa plate.  The sub-plates are shown as in a grey hachuring underlying the
coloured geological layer. Drak green lines separate to indicate the main movements in the internal African rifts.  Cretaceous and younger sedimentray rocks in
Afica are not shaded in order that the grey sub-fragment underlayer is visible.  Grey lines represent the main gravity anomaly marginal features.  Note these
particularly along the conjugate coastlines of Africa and South America.`}</p>
    <p>{` `}<em parentName="p">{`Last update: 2023 December 04`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      